var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('v-sheet',{attrs:{"height":"900"}},[_c('v-calendar',{ref:"calendar",attrs:{"now":_vm.today,"value":_vm.today,"events":_vm.events,"color":"primary","type":"week"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }